import { render, staticRenderFns } from "./a-initial-loader.vue?vue&type=template&id=08ca6118&"
import script from "./a-initial-loader.vue?vue&type=script&lang=js&"
export * from "./a-initial-loader.vue?vue&type=script&lang=js&"
import style0 from "./a-initial-loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports